export default __webpack_public_path__ + "static/mike-8b9daea4e5b01213f57ae5c32bf1988c.jpeg";